import { formatDateHHMM } from "../../../../../../../../utils/date";
import { useWalletLogContext } from "../../../../../hooks/wallet-log-context";
import { checkSeedLogType } from "../../../utils/log-type";
import {
  WalletLogsListRow,
  WalletLogListDate,
  WalletLogsListItemWrapper,
  WalletLogsListItem,
  WalletLogsListItemInfo,
  WalletLogsRowBorder,
} from "../style";

const WalletLogsSeedList = () => {
  const { seedLogs } = useWalletLogContext();

  const formatDate = (value: string) => {
    const [_, month, day] = value.split("-");
    return `${month}.${day}`;
  };

  return (
    <>
      {seedLogs.map((item, index) => (
        <>
          <WalletLogsListRow key={index}>
            <WalletLogListDate>{formatDate(item.date)}</WalletLogListDate>
            <WalletLogsListItemWrapper>
              {item.list.map((log, i) => (
                <WalletLogsListItem key={i}>
                  <WalletLogsListItemInfo>
                    <div className="info">
                      {log.pubName}{" "}
                      {checkSeedLogType(log.type) ? "지급" : "차감"}
                    </div>
                    <div className="date">
                      {formatDateHHMM(log.createdAt.toString())}
                    </div>
                  </WalletLogsListItemInfo>
                  <div className="point">
                    {checkSeedLogType(log.type) ? "+" : "-"}
                    {log.seed?.toLocaleString()} RABBIT
                  </div>
                </WalletLogsListItem>
              ))}
            </WalletLogsListItemWrapper>
          </WalletLogsListRow>
          <WalletLogsRowBorder />
        </>
      ))}
    </>
  );
};

export default WalletLogsSeedList;
